export default "__VITE_ASSET__BJQOnEuM__"